import { useState } from 'react';
import Tooltip from '@material-ui/core/Tooltip';
import { getElementToCopy } from '../../../store/global/selectors';
import Button from '@material-ui/core/Button';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import MenuOpenIcon from '@material-ui/icons/MenuOpen';
import { useSelector } from 'react-redux';
import { getEvents } from '../../../store/constructs/events/selectors';
import ReusedMessageAlert from '../../molecules/alerts/ReusedMessageAlert';
import { makeStyles } from '@material-ui/core';
const alertReqActions = ['add', 'delete', 'edit', 'paste'];

const useStyles = makeStyles({
    root: {
      '&:focus': {
        outline: 'none',
      },
      width: 'max-content'
    },
  });

export default function ActionIcon({ actions, messageId, disableBorder }) {
    const classes = useStyles()

    const elementToCopy = useSelector(getElementToCopy);
    const events = useSelector(getEvents);
    const [event, setEvent] = useState({});
    const [alert, setAlert] = useState(false);
    const eventsLinkedToMessageLength = events.filter(item => item.message === messageId).length;

    const scrollToTheTop = () => {
        // window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
        var myDiv = document.getElementById('bcrumb');
        myDiv?.scrollIntoView({ behavior: "smooth", block: "end", inline: "nearest" });

    }

    const doAction = (event) => {

        if (actions[event] === undefined)
            return false;

        if ((messageId !== undefined && messageId !== null && eventsLinkedToMessageLength > 1) && alertReqActions.includes(event)) {
            setAlert(true);
            setEvent(event);
            return;
        }

        actions[event].perform({
            id: actions[event].id,
            action: actions[event].action,
            item: actions[event].item,
            element: actions[event].element,
        })
    }

    const onContinue = () => {
        setAlert(false);

        if (actions[event] === undefined)
            return false;

        actions[event].perform({
            id: actions[event].id,
            action: actions[event].action,
            item: actions[event].item,
            element: actions[event].element,
        })
    }

    const [anchorEl, setAnchorEl] = useState(null);

    const handleClick = (event) => {
        event.preventDefault();
        setAnchorEl(event.currentTarget);
    };

    const handleClose = (action, event) => {
        event.preventDefault();
        setAnchorEl(null);
        doAction(action);
    };


    // style for action button container
    const actionButtonStyle = {
        textAlign: 'right'
    }
    if(disableBorder == undefined){
        actionButtonStyle.borderLeft = '1px solid #ccc'
    }


    return (
        <>
            {alert && <ReusedMessageAlert onContinue={onContinue} onClose={setAlert} messageId={messageId} />}


            <div className={"menu_options"} style={actionButtonStyle}>
                <Tooltip title="Options">
                    <Button data_schema_path="item_options_button" aria-controls="simple-menu" className={`${classes.root} item_options_button`} aria-haspopup="true" onClick={handleClick}>
                        <MenuOpenIcon size={'small'} color={'primary'} />
                    </Button>
                </Tooltip>
                <Menu
                    id="simple-menu"
                    className={"field_actions_menu"}
                    anchorEl={anchorEl}
                    keepMounted
                    open={Boolean(anchorEl)}
                    onClose={e => { handleClose('close', e) }}
                >
                    {actions.add !== undefined && <Tooltip title="Options1"><MenuItem onClick={e => { handleClose('add', e); scrollToTheTop() }} disabled={actions.add.disabled} className='popover-item-menu'>{actions.add.tooltip} </MenuItem></Tooltip>}
                    {actions.edit !== undefined && <MenuItem onClick={e => { handleClose('edit', e) }} disabled={actions.edit.disabled} className='popover-item-menu'>{actions.edit.tooltip}</MenuItem>}
                    {actions.delete !== undefined && <MenuItem onClick={e => handleClose('delete', e)} disabled={actions.delete.disabled} className='popover-item-menu'>{actions.delete.tooltip}</MenuItem>}
                    {actions.copy !== undefined && <MenuItem onClick={e => handleClose('copy', e)} disabled={actions.copy.disabled} className='popover-item-menu'>{actions.copy.tooltip}</MenuItem>}
                    {actions.paste !== undefined && <MenuItem onClick={e => handleClose('paste', e)} disabled={actions.paste.disabled} className='popover-item-menu'>{actions.paste.tooltip}</MenuItem>}
                    {actions.rename !== undefined && <MenuItem onClick={e => handleClose('rename', e)} disabled={actions.rename.disabled} className='popover-item-menu'>{actions.rename.tooltip}</MenuItem>}
                </Menu>
            </div>
        </>
    )
}